<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <LocationListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import LocationListing from "@/views/pages/admin/location/locationListing";

export default {
    page: {
        title: i18n.t("module.location"),
    },
    components: { Layout, PageHeader, LocationListing },
    data() {
        return {
            title: i18n.t("module.location"),
            items: [
                {
                    text: i18n.t("module.workplace"),
                    href: "/workplaces",
                },
                {
                    text: i18n.t("module.location"),
                    active: true,
                },
            ],
        };
    },
}
</script>
